
import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

interface TransacaoPontos {
  id: number;
  data: string;
  hora: string;
  tipo: 'credito' | 'debito';
  categoria: 'compra' | 'resgate' | 'bonus' | 'campanha' | 'estorno' | 'expiracao' | 'transferencia';
  descricao: string;
  pontos: number;
  saldoAnterior: number;
  saldoAtual: number;
  protocolo?: string;
  origem?: string;
  status: 'concluido' | 'pendente' | 'cancelado';
  dataExpiracao?: string;
  campanhaId?: number;
  campanhaNome?: string;
}

interface Campanha {
  id: number;
  nome: string;
  status: 'ativa' | 'pausada' | 'finalizada';
  dataInicio: string;
  dataFim: string;
  totalPontos: number;
  participantes: number;
}

export default function ExtratoPontosPage() {
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [filtroCategoria, setFiltroCategoria] = useState('todas');
  const [filtroPeriodo, setFiltroPeriodo] = useState('todos');
  const [filtroCampanha, setFiltroCampanha] = useState('todas');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const saldoAtual = 15750;

  // Lista de campanhas disponíveis
  const [campanhas] = useState<Campanha[]>([
    {
      id: 1,
      nome: 'Campanha de Vendas Q1 2024',
      status: 'ativa',
      dataInicio: '2024-01-01',
      dataFim: '2024-03-31',
      totalPontos: 25000,
      participantes: 45
    },
    {
      id: 2,
      nome: 'Campanha de Indicação',
      status: 'ativa',
      dataInicio: '2024-02-01',
      dataFim: '2024-12-31',
      totalPontos: 8000,
      participantes: 23
    },
    {
      id: 3,
      nome: 'Campanha de Produtividade',
      status: 'finalizada',
      dataInicio: '2024-01-15',
      dataFim: '2024-02-15',
      totalPontos: 12000,
      participantes: 38
    },
    {
      id: 4,
      nome: 'Campanha de Fidelidade',
      status: 'ativa',
      dataInicio: '2024-01-01',
      dataFim: '2024-12-31',
      totalPontos: 18500,
      participantes: 67
    },
    {
      id: 5,
      nome: 'Campanha de Engajamento',
      status: 'pausada',
      dataInicio: '2024-02-01',
      dataFim: '2024-04-30',
      totalPontos: 6800,
      participantes: 29
    },
    {
      id: 6,
      nome: 'Campanha de Performance',
      status: 'ativa',
      dataInicio: '2024-02-15',
      dataFim: '2024-05-15',
      totalPontos: 15200,
      participantes: 52
    },
    {
      id: 7,
      nome: 'Campanha de Inovação',
      status: 'finalizada',
      dataInicio: '2024-01-01',
      dataFim: '2024-01-31',
      totalPontos: 4500,
      participantes: 18
    }
  ]);

  const [transacoes] = useState<TransacaoPontos[]>([
    {
      id: 1,
      data: '2024-03-15',
      hora: '14:30:25',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra de pontos - Pacote Premium',
      pontos: 8000,
      saldoAnterior: 7750,
      saldoAtual: 15750,
      protocolo: 'CPT-2024-005678',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-03-15'
    },
    {
      id: 2,
      data: '2024-03-14',
      hora: '16:45:12',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - Vale-presente Amazon R$ 50,00',
      pontos: 2500,
      saldoAnterior: 10250,
      saldoAtual: 7750,
      protocolo: 'RES-2024-001234',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    },
    {
      id: 3,
      data: '2024-03-13',
      hora: '09:15:33',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus de boas-vindas - Programa de Incentivos',
      pontos: 1000,
      saldoAnterior: 9250,
      saldoAtual: 10250,
      protocolo: 'BON-2024-001122',
      status: 'concluido',
      dataExpiracao: '2025-03-13'
    },
    {
      id: 4,
      data: '2024-03-12',
      hora: '11:20:45',
      tipo: 'credito',
      categoria: 'campanha',
      descricao: 'Campanha de Vendas Q1 2024 - Meta atingida',
      pontos: 5000,
      saldoAnterior: 4250,
      saldoAtual: 9250,
      protocolo: 'CAM-2024-000567',
      origem: 'Campanha: Vendas Q1',
      status: 'concluido',
      dataExpiracao: '2025-03-12',
      campanhaId: 1,
      campanhaNome: 'Campanha de Vendas Q1 2024'
    },
    {
      id: 5,
      data: '2024-03-11',
      hora: '15:30:18',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - Smartphone Samsung Galaxy A54',
      pontos: 3500,
      saldoAnterior: 7750,
      saldoAtual: 4250,
      protocolo: 'RES-2024-001235',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    },
    {
      id: 6,
      data: '2024-03-10',
      hora: '13:45:22',
      tipo: 'credito',
      categoria: 'estorno',
      descricao: 'Estorno de resgate cancelado',
      pontos: 1500,
      saldoAnterior: 6250,
      saldoAtual: 7750,
      protocolo: 'EST-2024-000456',
      status: 'concluido',
      dataExpiracao: '2025-03-10'
    },
    {
      id: 7,
      data: '2024-03-09',
      hora: '10:12:55',
      tipo: 'debito',
      categoria: 'expiracao',
      descricao: 'Expiração de pontos - Lote 2023-03',
      pontos: 750,
      saldoAnterior: 7000,
      saldoAtual: 6250,
      protocolo: 'EXP-2024-000789',
      status: 'concluido'
    },
    {
      id: 8,
      data: '2024-03-08',
      hora: '08:30:10',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra de pontos - Pacote Básico',
      pontos: 3000,
      saldoAnterior: 4000,
      saldoAtual: 7000,
      protocolo: 'CPT-2024-005679',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-03-08'
    },
    {
      id: 9,
      data: '2024-03-07',
      hora: '17:22:33',
      tipo: 'credito',
      categoria: 'campanha',
      descricao: 'Campanha de Indicação - Novo cliente',
      pontos: 2000,
      saldoAnterior: 2000,
      saldoAtual: 4000,
      protocolo: 'CAM-2024-000568',
      origem: 'Campanha: Indicação',
      status: 'concluido',
      dataExpiracao: '2025-03-07',
      campanhaId: 2,
      campanhaNome: 'Campanha de Indicação'
    },
    {
      id: 10,
      data: '2024-03-06',
      hora: '12:15:44',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra inicial de pontos',
      pontos: 2000,
      saldoAnterior: 0,
      saldoAtual: 2000,
      protocolo: 'CPT-2024-005680',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-03-06'
    },
    {
      id: 11,
      data: '2024-03-05',
      hora: '14:22:10',
      tipo: 'credito',
      categoria: 'campanha',
      descricao: 'Campanha de Produtividade - Objetivo alcançado',
      pontos: 4500,
      saldoAnterior: 8500,
      saldoAtual: 13000,
      protocolo: 'CAM-2024-000569',
      origem: 'Campanha: Produtividade',
      status: 'concluido',
      dataExpiracao: '2025-03-05',
      campanhaId: 3,
      campanhaNome: 'Campanha de Produtividade'
    },
    {
      id: 12,
      data: '2024-03-04',
      hora: '09:45:33',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - Notebook Dell Inspiron 15',
      pontos: 6000,
      saldoAnterior: 14500,
      saldoAtual: 8500,
      protocolo: 'RES-2024-001236',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    },
    {
      id: 13,
      data: '2024-03-03',
      hora: '16:30:55',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus por participação em treinamento',
      pontos: 800,
      saldoAnterior: 13700,
      saldoAtual: 14500,
      protocolo: 'BON-2024-001123',
      status: 'concluido',
      dataExpiracao: '2025-03-03'
    },
    {
      id: 14,
      data: '2024-03-02',
      hora: '11:15:20',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra de pontos - Pacote Empresarial',
      pontos: 10000,
      saldoAnterior: 3700,
      saldoAtual: 13700,
      protocolo: 'CPT-2024-005681',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-03-02'
    },
    {
      id: 15,
      data: '2024-03-01',
      hora: '13:50:45',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - Smart TV Samsung 55" 4K',
      pontos: 5500,
      saldoAnterior: 9200,
      saldoAtual: 3700,
      protocolo: 'RES-2024-001237',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    },
    {
      id: 16,
      data: '2024-02-28',
      hora: '10:25:12',
      tipo: 'credito',
      categoria: 'campanha',
      descricao: 'Campanha de Fidelidade - Bônus mensal',
      pontos: 3200,
      saldoAnterior: 6000,
      saldoAtual: 9200,
      protocolo: 'CAM-2024-000570',
      origem: 'Campanha: Fidelidade',
      status: 'concluido',
      dataExpiracao: '2025-02-28',
      campanhaId: 4,
      campanhaNome: 'Campanha de Fidelidade'
    },
    {
      id: 17,
      data: '2024-02-27',
      hora: '15:40:30',
      tipo: 'debito',
      categoria: 'expiracao',
      descricao: 'Expiração de pontos - Lote 2023-02',
      pontos: 1200,
      saldoAnterior: 7200,
      saldoAtual: 6000,
      protocolo: 'EXP-2024-000790',
      status: 'concluido'
    },
    {
      id: 18,
      data: '2024-02-26',
      hora: '09:20:15',
      tipo: 'credito',
      categoria: 'estorno',
      descricao: 'Estorno de resgate não processado',
      pontos: 2500,
      saldoAnterior: 4700,
      saldoAtual: 7200,
      protocolo: 'EST-2024-000457',
      status: 'concluido',
      dataExpiracao: '2025-02-26'
    },
    {
      id: 19,
      data: '2024-02-25',
      hora: '14:10:40',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus por indicação de 3 novos clientes',
      pontos: 1500,
      saldoAnterior: 3200,
      saldoAtual: 4700,
      protocolo: 'BON-2024-001124',
      status: 'concluido',
      dataExpiracao: '2025-02-25'
    },
    {
      id: 20,
      data: '2024-02-24',
      hora: '11:55:25',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra de pontos - Pacote Gold',
      pontos: 7000,
      saldoAnterior: -3800,
      saldoAtual: 3200,
      protocolo: 'CPT-2024-005682',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-02-24'
    },
    {
      id: 21,
      data: '2024-02-23',
      hora: '16:35:50',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - iPhone 15 Pro 256GB',
      pontos: 12000,
      saldoAnterior: 8200,
      saldoAtual: -3800,
      protocolo: 'RES-2024-001238',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    },
    {
      id: 22,
      data: '2024-02-22',
      hora: '08:45:15',
      tipo: 'credito',
      categoria: 'campanha',
      descricao: 'Campanha de Engajamento - Participação ativa',
      pontos: 2800,
      saldoAnterior: 5400,
      saldoAtual: 8200,
      protocolo: 'CAM-2024-000571',
      origem: 'Campanha: Engajamento',
      status: 'concluido',
      dataExpiracao: '2025-02-22',
      campanhaId: 5,
      campanhaNome: 'Campanha de Engajamento'
    },
    {
      id: 23,
      data: '2024-02-21',
      hora: '13:20:40',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus de aniversário do programa',
      pontos: 1000,
      saldoAnterior: 4400,
      saldoAtual: 5400,
      protocolo: 'BON-2024-001125',
      status: 'concluido',
      dataExpiracao: '2025-02-21'
    },
    {
      id: 24,
      data: '2024-02-20',
      hora: '10:15:30',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra de pontos - Pacote Platinum',
      pontos: 15000,
      saldoAnterior: -10600,
      saldoAtual: 4400,
      protocolo: 'CPT-2024-005683',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-02-20'
    },
    {
      id: 25,
      data: '2024-02-19',
      hora: '15:50:20',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - PlayStation 5 + 2 Jogos',
      pontos: 8500,
      saldoAnterior: -2100,
      saldoAtual: -10600,
      protocolo: 'RES-2024-001239',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    },
    {
      id: 26,
      data: '2024-02-18',
      hora: '09:30:45',
      tipo: 'credito',
      categoria: 'campanha',
      descricao: 'Campanha de Performance - Top 10 vendedores',
      pontos: 6000,
      saldoAnterior: -8100,
      saldoAtual: -2100,
      protocolo: 'CAM-2024-000572',
      origem: 'Campanha: Performance',
      status: 'concluido',
      dataExpiracao: '2025-02-18',
      campanhaId: 6,
      campanhaNome: 'Campanha de Performance'
    },
    {
      id: 27,
      data: '2024-02-17',
      hora: '14:25:10',
      tipo: 'debito',
      categoria: 'expiracao',
      descricao: 'Expiração de pontos - Lote 2023-01',
      pontos: 2000,
      saldoAnterior: -6100,
      saldoAtual: -8100,
      protocolo: 'EXP-2024-000791',
      status: 'concluido'
    },
    {
      id: 28,
      data: '2024-02-16',
      hora: '11:40:35',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus por completar desafio semanal',
      pontos: 1200,
      saldoAnterior: -7300,
      saldoAtual: -6100,
      protocolo: 'BON-2024-001126',
      status: 'concluido',
      dataExpiracao: '2025-02-16'
    },
    {
      id: 29,
      data: '2024-02-15',
      hora: '16:15:50',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra de pontos - Pacote Mega',
      pontos: 20000,
      saldoAnterior: -27300,
      saldoAtual: -7300,
      protocolo: 'CPT-2024-005684',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-02-15'
    },
    {
      id: 30,
      data: '2024-02-14',
      hora: '08:55:25',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - MacBook Air M2 13"',
      pontos: 18000,
      saldoAnterior: -9300,
      saldoAtual: -27300,
      protocolo: 'RES-2024-001240',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    },
    {
      id: 31,
      data: '2024-02-13',
      hora: '13:30:15',
      tipo: 'credito',
      categoria: 'campanha',
      descricao: 'Campanha de Inovação - Sugestão implementada',
      pontos: 3500,
      saldoAnterior: -12800,
      saldoAtual: -9300,
      protocolo: 'CAM-2024-000573',
      origem: 'Campanha: Inovação',
      status: 'concluido',
      dataExpiracao: '2025-02-13',
      campanhaId: 7,
      campanhaNome: 'Campanha de Inovação'
    },
    {
      id: 32,
      data: '2024-02-12',
      hora: '10:20:40',
      tipo: 'credito',
      categoria: 'estorno',
      descricao: 'Estorno de pontos debitados incorretamente',
      pontos: 4200,
      saldoAnterior: -17000,
      saldoAtual: -12800,
      protocolo: 'EST-2024-000458',
      status: 'concluido',
      dataExpiracao: '2025-02-12'
    },
    {
      id: 33,
      data: '2024-02-11',
      hora: '15:45:25',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus por atingir 100% de presença',
      pontos: 900,
      saldoAnterior: -17900,
      saldoAtual: -17000,
      protocolo: 'BON-2024-001127',
      status: 'concluido',
      dataExpiracao: '2025-02-11'
    },
    {
      id: 34,
      data: '2024-02-10',
      hora: '09:10:50',
      tipo: 'credito',
      categoria: 'compra',
      descricao: 'Compra de pontos - Pacote Starter',
      pontos: 5000,
      saldoAnterior: -22900,
      saldoAtual: -17900,
      protocolo: 'CPT-2024-005685',
      origem: 'Compra via Conta Digital',
      status: 'concluido',
      dataExpiracao: '2025-02-10'
    },
    {
      id: 35,
      data: '2024-02-09',
      hora: '14:35:30',
      tipo: 'debito',
      categoria: 'resgate',
      descricao: 'Resgate - Apple Watch Series 9',
      pontos: 7500,
      saldoAnterior: -15400,
      saldoAtual: -22900,
      protocolo: 'RES-2024-001241',
      origem: 'Loja de Recompensas',
      status: 'concluido'
    }
  ]);

  const filteredTransacoes = transacoes.filter(t => {
    const matchesSearch = t.descricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         t.protocolo?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesTipo = filtroTipo === 'todos' || t.tipo === filtroTipo;
    const matchesCategoria = filtroCategoria === 'todas' || t.categoria === filtroCategoria;
    const matchesCampanha = filtroCampanha === 'todas' || 
                           (filtroCampanha === 'sem-campanha' && !t.campanhaId) ||
                           (t.campanhaId && t.campanhaId.toString() === filtroCampanha);
    
    // Filtro de período
    const dataTransacao = new Date(t.data);
    const hoje = new Date();
    let matchesPeriodo = true;
    
    if (filtroPeriodo === '7dias') {
      const seteDiasAtras = new Date(hoje.getTime() - 7 * 24 * 60 * 60 * 1000);
      matchesPeriodo = dataTransacao >= seteDiasAtras;
    } else if (filtroPeriodo === '30dias') {
      const trintaDiasAtras = new Date(hoje.getTime() - 30 * 24 * 60 * 60 * 1000);
      matchesPeriodo = dataTransacao >= trintaDiasAtras;
    } else if (filtroPeriodo === '90dias') {
      const noventaDiasAtras = new Date(hoje.getTime() - 90 * 24 * 60 * 60 * 1000);
      matchesPeriodo = dataTransacao >= noventaDiasAtras;
    } else if (filtroPeriodo === 'personalizado' && dataInicio && dataFim) {
      const inicio = new Date(dataInicio);
      const fim = new Date(dataFim);
      matchesPeriodo = dataTransacao >= inicio && dataTransacao <= fim;
    } else if (filtroPeriodo === 'todos') {
      matchesPeriodo = true;
    }
    
    return matchesSearch && matchesTipo && matchesCategoria && matchesCampanha && matchesPeriodo;
  });

  const getTipoColor = (tipo: string) => {
    return tipo === 'credito' ? 'text-emerald-600' : 'text-red-600';
  };

  const getTipoIcon = (tipo: string) => {
    return tipo === 'credito' ? 'ri-arrow-up-line' : 'ri-arrow-down-line';
  };

  const getCategoriaIcon = (categoria: string) => {
    const icons = {
      'compra': 'ri-shopping-cart-line',
      'resgate': 'ri-gift-line',
      'bonus': 'ri-star-line',
      'campanha': 'ri-trophy-line',
      'estorno': 'ri-refund-line',
      'expiracao': 'ri-time-line',
      'transferencia': 'ri-exchange-line'
    };
    return icons[categoria as keyof typeof icons] || 'ri-coin-line';
  };

  const getCategoriaLabel = (categoria: string) => {
    const labels = {
      'compra': 'Compra',
      'resgate': 'Resgate',
      'bonus': 'Bônus',
      'campanha': 'Campanha',
      'estorno': 'Estorno',
      'expiracao': 'Expiração',
      'transferencia': 'Transferência'
    };
    return labels[categoria as keyof typeof labels] || categoria;
  };

  const getStatusColor = (status: string) => {
    const colors = {
      'concluido': 'bg-emerald-100 text-emerald-800',
      'pendente': 'bg-yellow-100 text-yellow-800',
      'cancelado': 'bg-red-100 text-red-800'
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getStatusLabel = (status: string) => {
    const labels = {
      'concluido': 'Concluído',
      'pendente': 'Pendente',
      'cancelado': 'Cancelado'
    };
    return labels[status as keyof typeof labels] || status;
  };

  const getCampanhaStatusColor = (status: string) => {
    const colors = {
      'ativa': 'bg-emerald-100 text-emerald-800',
      'pausada': 'bg-yellow-100 text-yellow-800',
      'finalizada': 'bg-gray-100 text-gray-800'
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const totalCreditos = filteredTransacoes
    .filter(t => t.tipo === 'credito')
    .reduce((sum, t) => sum + t.pontos, 0);

  const totalDebitos = filteredTransacoes
    .filter(t => t.tipo === 'debito')
    .reduce((sum, t) => sum + t.pontos, 0);

  // Estatísticas da campanha selecionada
  const campanhaEstatisticas = () => {
    if (filtroCampanha === 'todas' || filtroCampanha === 'sem-campanha') {
      return null;
    }
    
    const campanha = campanhas.find(c => c.id.toString() === filtroCampanha);
    const transacoesCampanha = filteredTransacoes.filter(t => t.campanhaId?.toString() === filtroCampanha);
    const pontosCampanha = transacoesCampanha.reduce((sum, t) => sum + (t.tipo === 'credito' ? t.pontos : 0), 0);
    
    return { campanha, transacoesCampanha, pontosCampanha };
  };

  const estatisticas = campanhaEstatisticas();

  const exportarExtrato = () => {
    // Simular exportação
    const csvContent = 'data,hora,tipo,categoria,descricao,pontos,saldo_anterior,saldo_atual,protocolo,status,data_expiracao,campanha\\n' +
      filteredTransacoes.map(t => 
        `${t.data},${t.hora},${t.tipo},${t.categoria},"${t.descricao}",${t.pontos},${t.saldoAnterior},${t.saldoAtual},${t.protocolo || ''},${t.status},${t.dataExpiracao || ''},"${t.campanhaNome || ''}"`
      ).join('\\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `extrato_pontos_incentivo_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center space-x-2 mb-2">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/admin')}
                className="text-blue-600 hover:text-blue-800 cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </div>
              </button>
              <span className="text-sm text-gray-500">Dashboard</span>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <span className="text-sm text-gray-900">Extrato Pontos de Incentivo</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Extrato de Pontos de Incentivo</h1>
            <p className="text-gray-600 mt-1">Histórico completo de movimentações de pontos por campanha</p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={exportarExtrato}
              className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-line"></i>
              </div>
              <span>Exportar</span>
            </button>
          </div>
        </div>

        {/* Informações da Campanha Selecionada */}
        {estatisticas && (
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-trophy-line text-white text-xl"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{estatisticas.campanha?.nome}</h3>
                  <div className="flex items-center space-x-2 mt-1">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCampanhaStatusColor(estatisticas.campanha?.status || '')}`}>
                      {estatisticas.campanha?.status === 'ativa' ? 'Ativa' : 
                       estatisticas.campanha?.status === 'pausada' ? 'Pausada' : 'Finalizada'}
                    </span>
                    <span className="text-sm text-gray-600">
                      {new Date(estatisticas.campanha?.dataInicio || '').toLocaleDateString('pt-BR')} - {new Date(estatisticas.campanha?.dataFim || '').toLocaleDateString('pt-BR')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white rounded-lg p-4 border border-blue-100">
                <p className="text-sm text-gray-600">Pontos da Campanha</p>
                <p className="text-2xl font-bold text-blue-600 mt-1">{estatisticas.pontosCampanha.toLocaleString('pt-BR')} pts</p>
              </div>
              <div className="bg-white rounded-lg p-4 border border-blue-100">
                <p className="text-sm text-gray-600">Transações</p>
                <p className="text-2xl font-bold text-blue-600 mt-1">{estatisticas.transacoesCampanha.length}</p>
              </div>
              <div className="bg-white rounded-lg p-4 border border-blue-100">
                <p className="text-sm text-gray-600">Participantes</p>
                <p className="text-2xl font-bold text-blue-600 mt-1">{estatisticas.campanha?.participantes}</p>
              </div>
            </div>
          </div>
        )}

        {/* Resumo */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Saldo Atual</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">
                  {saldoAtual.toLocaleString('pt-BR')} pts
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-purple-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-coin-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pontos Creditados</p>
                <p className="text-2xl font-bold text-emerald-600 mt-2">
                  {totalCreditos.toLocaleString('pt-BR')} pts
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-emerald-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-arrow-up-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pontos Utilizados</p>
                <p className="text-2xl font-bold text-red-600 mt-2">
                  {totalDebitos.toLocaleString('pt-BR')} pts
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-red-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Transações</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{filteredTransacoes.length}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-blue-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-file-list-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-4">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-gray-400"></i>
                </div>
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm w-full"
                placeholder="Buscar transações..."
              />
            </div>

            <select
              value={filtroCampanha}
              onChange={(e) => setFiltroCampanha(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
            >
              <option value="todas">Todas as Campanhas</option>
              <option value="sem-campanha">Sem Campanha</option>
              {campanhas.map(campanha => (
                <option key={campanha.id} value={campanha.id.toString()}>
                  {campanha.nome}
                </option>
              ))}
            </select>
            
            <select
              value={filtroTipo}
              onChange={(e) => setFiltroTipo(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
            >
              <option value="todos">Todos os Tipos</option>
              <option value="credito">Ganhos</option>
              <option value="debito">Utilizados</option>
            </select>

            <select
              value={filtroCategoria}
              onChange={(e) => setFiltroCategoria(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
            >
              <option value="todas">Todas as Categorias</option>
              <option value="compra">Compras</option>
              <option value="resgate">Resgates</option>
              <option value="bonus">Bônus</option>
              <option value="campanha">Campanhas</option>
              <option value="estorno">Estornos</option>
              <option value="expiracao">Expirações</option>
            </select>

            <select
              value={filtroPeriodo}
              onChange={(e) => setFiltroPeriodo(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
            >
              <option value="todos">Todos os períodos</option>
              <option value="7dias">Últimos 7 dias</option>
              <option value="30dias">Últimos 30 dias</option>
              <option value="90dias">Últimos 90 dias</option>
              <option value="personalizado">Período personalizado</option>
            </select>

            {filtroPeriodo === 'personalizado' && (
              <>
                <input
                  type="date"
                  value={dataInicio}
                  onChange={(e) => setDataInicio(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
                <input
                  type="date"
                  value={dataFim}
                  onChange={(e) => setDataFim(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
              </>
            )}
          </div>
        </div>

        {/* Tabela de Transações */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Tipo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Descrição
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Campanha
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Pontos
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Saldo Anterior
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Saldo Atual
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredTransacoes.map((transacao) => (
                  <tr key={transacao.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {new Date(transacao.data).toLocaleDateString('pt-BR')}
                      </div>
                      <div className="text-xs text-gray-500">{transacao.hora}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center space-x-2">
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                          transacao.tipo === 'credito' ? 'bg-emerald-100' : 'bg-red-100'
                        }`}>
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className={`${getCategoriaIcon(transacao.categoria)} ${getTipoColor(transacao.tipo)}`}></i>
                          </div>
                        </div>
                        <span className={`text-sm font-medium ${getTipoColor(transacao.tipo)}`}>
                          {transacao.tipo === 'credito' ? 'Creditado' : 'Utilizado'}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm font-medium text-gray-900">{transacao.descricao}</div>
                      <div className="text-xs text-gray-500 mt-1">{getCategoriaLabel(transacao.categoria)}</div>
                      {transacao.origem && (
                        <div className="text-xs text-gray-400 mt-1">{transacao.origem}</div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {transacao.campanhaNome ? (
                        <div className="flex items-center space-x-2">
                          <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                            <div className="w-3 h-3 flex items-center justify-center">
                              <i className="ri-trophy-line text-blue-600 text-xs"></i>
                            </div>
                          </div>
                          <span className="text-sm text-gray-900">{transacao.campanhaNome}</span>
                        </div>
                      ) : (
                        <span className="text-sm text-gray-400">-</span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center space-x-1">
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className={`${getTipoIcon(transacao.tipo)} ${getTipoColor(transacao.tipo)}`}></i>
                        </div>
                        <span className={`text-sm font-bold ${getTipoColor(transacao.tipo)}`}>
                          {transacao.tipo === 'credito' ? '+' : '-'}{transacao.pontos.toLocaleString('pt-BR')} pts
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-900">
                        {transacao.saldoAnterior.toLocaleString('pt-BR')} pts
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-semibold text-gray-900">
                        {transacao.saldoAtual.toLocaleString('pt-BR')} pts
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {filteredTransacoes.length === 0 && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
            <div className="w-16 h-16 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-coin-line text-gray-400 text-2xl"></i>
              </div>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhuma transação encontrada</h3>
            <p className="text-gray-500">Tente ajustar os filtros para encontrar as transações desejadas.</p>
          </div>
        )}
      </div>
    </Layout>
  );
}
